import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'

import { useSnackbar } from '../components/Snackbar'
import { isKeywordGraphApp } from '../appVariant'
import { useOnboardingStore } from '../stores/useOnboardingStore'

const selectorShowSnackbar = state => state.showSnackbar

export default function AppsIntroSection() {
    const showSnackbar = useSnackbar(selectorShowSnackbar)
    const isMobile = useMediaQuery('(max-width:600px)')
    // Hold the promo snackbar back while the onboarding guide is (or may
    // still turn out to be) showing — the two collide at the top of /apps.
    const onboardingStatus = useOnboardingStore(state => state.status)

    React.useEffect(() => {
        if (isMobile) return
        if (onboardingStatus === 'unknown' || onboardingStatus === 'active')
            return
        const message = isKeywordGraphApp()
            ? `Supercharge your browsing & note-taking with the new 3D knowledge graph.<br>Download our <a href="/extension" target="_blank">browser extension for Google / web</a> and check our <a href="/mcp" target="_blank">SEO MCP server</a>.`
            : `You are using the new version of InfraNodus. To switch to the legacy version, please, <a href="https://legacy.infranodus.com/login">click here to log in</a>.`
        // showSnackbar('info', message, 'top-right', 20000)
    }, [showSnackbar, isMobile, onboardingStatus])

    return (
        <>
            <Box
                sx={{
                    pt: 0,
                    pb: 2,
                    mt: 2,
                    // Same left-only-gutter fix as AppsOutroSection.
                    pl: { xs: 0, sm: '32px' },
                    pr: 4,
                    maxWidth: '800px',
                }}
            >
                <Typography
                    component="p"
                    variant="subtitle1"
                    align="left"
                    color="text.primary"
                >
                    {isKeywordGraphApp() ? (
                        <>
                            Visual SEO / LLMO tools to find patterns in search
                            intent and results.
                        </>
                    ) : (
                        <>
                            Generate insights and steer your LLM's reasoning
                            using knowledge graphs.
                        </>
                    )}
                </Typography>
            </Box>
        </>
    )
}
